// Awarding list: status tones and the Excel/CSV export. Download helpers are
// shared with the Plan & Procurement list.

import { downloadSheet } from '../../Procurement/utils/procurementList';
import { AWARDING_STATUS_OPTIONS } from './awardingHelpers';

// `value` is the Status query value. `tone` drives the to-status / to-mcard
// modifier, `stat` the to-stat one.
const STATUS_META = {
  Open: { icon: 'ri-door-open-line', tone: 'info', stat: 'open' },
  InProgress: { icon: 'ri-loader-4-line', tone: 'warning', stat: 'progress' },
  Confirmed: {
    icon: 'ri-checkbox-circle-line',
    tone: 'success',
    stat: 'done',
  },
};

export const AWARDING_STATUSES = AWARDING_STATUS_OPTIONS.map(option => ({
  ...option,
  ...STATUS_META[option.value],
}));

// Row status wordings ("In Progress", "InProgress", ...) -> tone.
export const getAwardingTone = status => {
  const key = String(status ?? '')
    .replace(/\s+/g, '')
    .toLowerCase();
  if (key === 'confirmed') return 'success';
  if (key === 'inprogress') return 'warning';
  if (key === 'open') return 'info';
  if (key === 'rejected' || key === 'cancelled') return 'danger';
  return 'muted';
};

const toExportRow = row => ({
  'No Proc': row.noProc || '',
  Title: row.title || '',
  'Proc Type': row.procType || '',
  Product: row.productType?.main || '',
  'Product Type':
    row.productType?.sub && row.productType.sub !== '-'
      ? row.productType.sub
      : '',
  Description: row.description || '',
  Status: row.status || '',
});

export const exportAwardingList = (rows, opts) =>
  downloadSheet(rows.map(toExportRow), { ...opts, prefix: 'Awarding' });
